
/**
 * LLM Providers Tab Help Content
 */
const LLMProvidersHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          LLM Providers
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Configure your LLM provider credentials for features like LLM-as-Judge evaluations and automated prompt testing.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Supported Providers
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">OpenAI</span>: GPT-4, GPT-3.5 Turbo models</p>
          <p>&#8226; <span className="font-medium">Anthropic</span>: Claude 3 family models</p>
          <p>&#8226; <span className="font-medium">AWS Bedrock</span>: Claude, Titan, and other models</p>
          <p>&#8226; <span className="font-medium">Azure OpenAI</span>: Enterprise OpenAI deployments</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Adding a Provider
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          To configure a new provider:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>1. Select the provider type</p>
          <p>2. Enter your API key or credentials</p>
          <p>3. Configure optional settings (region, endpoint)</p>
          <p>4. Test the connection</p>
          <p>5. Save the configuration</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Use Cases
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">LLM-as-Judge</span>: Semantic evaluation of agent outputs</p>
          <p>&#8226; <span className="font-medium">Auto-Evaluation</span>: Automated prompt quality scoring</p>
          <p>&#8226; <span className="font-medium">Test Generation</span>: AI-assisted test case creation</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Security
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Credentials are encrypted at rest and in transit. They are only used server-side for configured features and never exposed to the frontend.
        </p>
      </div>

      <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-500">
          Configure <span className="font-medium">Judge Rubrics</span> to customize evaluation criteria.
        </p>
      </div>
    </>
  );
};

export default LLMProvidersHelp;
